export default "__VITE_ASSET__2993cf83__"